import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Checkbox, Header } from 'semantic-ui-react';

import {getCategoryImageUrl, isEnabled, getNotification, getNotificationFrequency, formatTime} from './tools.js';
import Utils from 'utils/Utils.js';
import ProgressBar from 'modules/misc/ProgressBar.js';
import LoadInline from '../loading/LoadInline.js';
import {spacings, colors, layout} from 'style';

var style = {
    content: {
        // padding: '1px',
        position:'relative'
    },
    container : {
        padding: '1px'
    },
    loaderContainer: {
        marginLeft:'50%'
    },
    subtitle: {
        textAlign: 'center',
    },
    card: {
        overflow:'hidden',
        color: '#fff',
        backgroundColor: colors.themeBlue,
    },
    header: {
        fontSize: '1em',
        color:'#fff', 
    },
    description: {
        color:'#fff', 
    },
    meta: {
        color:'#fff', 
    },
    iconHeader: {
        height:'42px', 
        padding:'10px 0px 0px 10px', 
        width:'100%',
        color: '#fff',
        backgroundColor: colors.themeTeal,
    },
    imageBanner: {
        position: 'relative',
        height:'158px', 
        width:'100%',
        backgroundSize:'100%',
        backgroundPositionY: 'center',
    },
    checkmark: {
        position: 'absolute',
        bottom: '-15px',
        right: '5px',
        width: '42px',
        height: '42px',
        paddingTop: '8px',
        boxShadow: 'none',
        borderWidth: '3px',
        borderStyle: 'solid',
        color: colors.themeTeal,
        borderColor: colors.themeTeal,
        borderRadius: '50%',
        backgroundColor: '#fff',
    },
    addNewGoalIcon: {
        backgroundColor: '#fff',
        color: colors.themeBlue,
        border: 'none',
        boxShadow: 'none',
    },
    addNewGoalBanner: {
        textAlign:'center', 
        lineHeight: '160px',
    },
    progressInfo: {
        paddingTop: spacings.small,
        paddingLeft: '80px',
        paddingRight: '80px',
        height: '64px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
    },
    progressContainer:{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: layout.screenWidth,
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
    },
    levelText: {
        paddingTop: '3px',
        fontWeight: 'light',
        fontSize: '0.95em',
        textAlign: 'center',
    },
    progressBar: {
        height: '12px',
        backgroundColor: '#fff',
    },
};

const Categories = ({t, 
                     categories, 
                     onClickCategory, 
                     busy, 
                     objective, 
                     onAddNewGoal,
                     categoriesLimit,
                     categoriesCount,
                     userLimit}) => (
    <div className="full-height" style={style.content}>
        {categoriesLimit &&
            <div style={style.progressInfo} className='rewards-progressInfo'>
                <div style={style.progressContainer}>
                    <ProgressBar style={style.progressBar} value={categoriesCount} total={userLimit} borderWidth={'0'} />
                    <div style={style.levelText}>
                        {t('user_limit_[val]_[limit]',{val:categories.length, limit:userLimit})}
                    </div>
                </div>
            </div>
        }
        <div style={style.container}>
            <Segment>
                {objective &&
                <Header style={style.subtitle} size="tiny">{objective.title} <Icon className='icon-chevron-down'/></Header>
                }
                
                {busy && 
                    <div style={style.loaderContainer}>
                        <LoadInline /> 
                    </div>
                }
                {!busy && 
                <Card.Group>
                {categories.map((category)=>(
                            <Card key={category.id} style={style.card} onClick={()=>onClickCategory(category.id)}>
                                <div style={style.iconHeader}>
                                    <Icon size='large' className={category.icon}></Icon> 
                                    {category.title}
                                </div>
                                <div style={{...style.imageBanner, backgroundImage:Utils.url(getCategoryImageUrl(category))}}>
                                {isEnabled(category) &&
                                    <Icon style={style.checkmark} size='large' name='checkmark' />
                                }
                                </div>
                                <Card.Content>
                                    <Card.Header style={style.header}>
                                        {category.levelReq > 1 &&
                                            <Card.Meta style={style.meta}>Level {category.levelReq}</Card.Meta>
                                        }
                                    </Card.Header>
                                    {(((category.notifications && category.notifications[0]) ? category.notifications[0].time : category.defaultTime)>=0) &&
                                        <Card.Meta style={style.meta}>{t('Scheduled_Time_{{t}}', {t: formatTime((category.notifications && category.notifications[0]) ? category.notifications[0].time : category.defaultTime)})}</Card.Meta>
                                    }
                                    <Card.Meta style={style.meta}>{t('Frequency_{{f}}', {f:getNotificationFrequency(t, getNotification(category))})}</Card.Meta>
                                </Card.Content>
                            </Card>
                        )
                    )    
                }
                {onAddNewGoal &&
                    <Card key='addNewGoal' style={style.card} onClick={onAddNewGoal}>
                        <div style={style.iconHeader}>
                        </div>
                        <div style={{...style.imageBanner, ...style.addNewGoalBanner}}>
                            <Icon style={style.addNewGoalIcon} size='huge' circular className='icon-plus'></Icon> 
                        </div>
                        <Card.Content>
                            <Card.Header style={style.header} textAlign='center'>
                                {t('Add New Goal')}
                            </Card.Header>
                        </Card.Content>
                    </Card>
                }
                </Card.Group>
                }
            </Segment>
        </div>
    </div>
);


export default translate('categories')(Categories);



// WEBPACK FOOTER //
// ./src/modules/categories/Categories.js